import React, { useEffect, useRef, useState } from 'react'
import { useLocalization } from 'gatsby-theme-i18n'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'
import ExpandIcon from '../Icons/ExpandIcon'
import HideIcon from '../Icons/HideIcon'
import clsx from 'clsx'

const optionClass = (currLocale) =>
  clsx(
    'px-3 py-1 first:rounded-t last:rounded-b ',
    currLocale ? 'bg-brand-primary text-white' : 'bg-white hover:bg-[#ddfff3]'
  )

const dropdownClass = (isOpen) =>
  clsx(
    'absolute  max-xl:right-0 max-xl:bottom-10 min-w-56 shadow-lg rounded pt-2',
    isOpen ? 'block' : 'hidden'
  )

const LanguageSwitcher = () => {
  const { locale, defaultLang, config } = useLocalization()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const location = useLocation()

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  const switchLanguage = (value) => {
    if (value.code === locale) {
      return
    }
    const currentPath = location.pathname.replace(/^\/[a-z]{2}\//, '/')

    if (value.code === defaultLang) {
      navigate(currentPath)
    } else {
      navigate(`/${value.code}${currentPath}`)
    }

    setOpen(false)
  }

  return (
    <div
      className='group relative inline-block text-xl leading-normal font-normal transition'
      ref={ref}
    >
      <button
        onClick={() => setOpen(!open)}
        className='cursor-none flex items-center gap-2 text-xl leading-normal'
      >
        {locale[0].toUpperCase() + locale[1]}
        <ExpandIcon
          width='16'
          height='16'
          className={open ? 'hidden' : 'block'}
        />
        <HideIcon
          width='16'
          height='16'
          className={open ? 'block' : 'hidden'}
        />
      </button>
      <span className='block max-w-0 h-0.5 bg-brand-primary transition-[max-width] xl:group-hover:max-w-full' />
      <div className={dropdownClass(open)}>
        {config.map((elem) => (
          <div
            key={elem.code}
            onClick={() => switchLanguage(elem)}
            className={optionClass(elem.code === locale)}
          >
            {elem.localName}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LanguageSwitcher
